(() => {
  const galleries = new WeakMap();
  function init(root = document) {
    root.querySelectorAll('[data-drf-gallery]').forEach((gallery) => {
      if (galleries.has(gallery)) return;
      const section = gallery.closest('[data-section-id]') || gallery.parentElement;
      const controller = new AbortController();
      const listen = (element, type, fn) => element.addEventListener(type, fn, { signal: controller.signal });
      const controls = document.createElement('div');
      controls.className = 'drf-gallery-controls';
      const drfS = window.drfStrings || {};
      controls.innerHTML = '<button type="button" aria-label="' + (drfS.galleryPrevious || 'Vorheriges Produktbild') + '">‹</button><span aria-live="polite" aria-atomic="true"></span><button type="button" aria-label="' + (drfS.galleryNext || 'Nächstes Produktbild') + '">›</button>';
      gallery.after(controls);
      gallery.tabIndex = 0;
      gallery.setAttribute('role', 'region');
      gallery.setAttribute('aria-roledescription', drfS.galleryRole || 'Karussell');
      gallery.setAttribute('aria-label', drfS.galleryLabel || 'Produktbilder');
      const status = controls.querySelector('span');
      let index = 0;
      let current;
      let requestedId;
      const slides = () => [...gallery.querySelectorAll(':scope > [data-media-slide]')].filter((slide) => !slide.classList.contains('hide'));
      function sync() {
        const items = slides();
        controls.hidden = items.length < 2;
        if (!items.length) { status.textContent = ''; return; }
        const left = gallery.getBoundingClientRect().left;
        index = items.reduce((best, slide, i) => Math.abs(slide.getBoundingClientRect().left - left) < Math.abs(items[best].getBoundingClientRect().left - left) ? i : best, 0);
        if (current !== items[index]) {
          current?.dispatchEvent(new CustomEvent('pause'));
          current = items[index];
        }
        items.forEach((slide, i) => { slide.inert = i !== index; });
        const label = `${index + 1} / ${items.length}`;
        if (status.textContent !== label) status.textContent = label;
        section.querySelectorAll('[data-media-select]').forEach((thumb) => {
          const active = thumb.dataset.mediaSelect === current.dataset.mediaId;
          thumb.classList.toggle('is-activated', active);
          thumb.setAttribute('aria-current', String(active));
        });
      }
      function select(next) {
        const items = slides();
        if (!items.length) return;
        const target = items[(next + items.length) % items.length];
        gallery.scrollBy({ left: target.getBoundingClientRect().left - gallery.getBoundingClientRect().left, behavior: 'instant' });
        sync();
      }
      const buttons = controls.querySelectorAll('button');
      listen(buttons[0], 'click', () => select(index - 1));
      listen(buttons[1], 'click', () => select(index + 1));
      listen(gallery, 'scroll', sync);
      listen(gallery, 'keydown', (event) => {
        if (event.target !== gallery) return;
        const rtl = getComputedStyle(gallery).direction === 'rtl';
        const next = { ArrowRight: index + (rtl ? -1 : 1), ArrowLeft: index + (rtl ? 1 : -1), Home: 0, End: slides().length - 1 }[event.key];
        if (next === undefined) return;
        event.preventDefault(); select(next);
      });
      listen(gallery, 'theme:image:change', (event) => {
        requestedId = String(event.detail.id);
        const next = slides().findIndex((slide) => slide.dataset.mediaId === requestedId);
        if (next >= 0) select(next);
      });
      section.querySelectorAll('[data-media-select]').forEach((thumb) => listen(thumb, 'click', () => {
        const next = slides().findIndex((slide) => slide.dataset.mediaId === thumb.dataset.mediaSelect);
        if (next >= 0) select(next);
      }));
      const resize = new ResizeObserver(() => select(index));
      resize.observe(gallery);
      const filters = new MutationObserver(() => {
        const next = slides().findIndex((slide) => slide.dataset.mediaId === requestedId);
        select(next >= 0 ? next : 0); sync();
      });
      gallery.querySelectorAll(':scope > [data-media-slide]').forEach((slide) => filters.observe(slide, { attributes: true, attributeFilter: ['class'] }));
      galleries.set(gallery, () => { controller.abort(); resize.disconnect(); filters.disconnect(); controls.remove(); galleries.delete(gallery); });
      sync();
      // Editor-inserted product forms can initialize before section:load fires.
      // Recover their selected variant without changing any product/form data.
      const productJSON = section.querySelector('[data-product-json]');
      const variantId = section.querySelector('[name="id"]')?.value;
      if (productJSON && variantId) {
        try {
          const variant = JSON.parse(productJSON.textContent).variants?.find((item) => String(item.id) === variantId);
          if (variant?.featured_media?.id) {
            requestedId = String(variant.featured_media.id);
            const next = slides().findIndex((slide) => slide.dataset.mediaId === requestedId);
            if (next >= 0) select(next);
          }
        } catch (error) {
          console.warn('[DRF Gallery] Invalid product JSON', error);
        }
      }
    });
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => event.target.querySelectorAll('[data-drf-gallery]').forEach((gallery) => galleries.get(gallery)?.()));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
})();